import { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Input,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DeleteOutline } from '@material-ui/icons';
import commonStyles from '../../../../styles';
import gensenStyle from '../../../../gensenRegister/parts/gensenRegisterStyles';
import { compressImage } from '../../../../../commonFunction/compressImage';
import { formatFileName } from '../../../../../commonFunction';

const useStyles = makeStyles((theme) => ({
  deleteBtn: {
    color: '#D83420',
    width: '15.4%',
    '& .MuiButton-label': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  inputWrap: {
    position: 'relative',
    width: '70%',
    '& .MuiInput-root': {
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      '&::before': {
        content: 'none',
      },
      '&::after': {
        content: 'none',
      },
    },
  },
  boxLbl: {
    zIndex: 2,
    color: theme.palette.primaryColor,
    background: '#fff',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 700,
    lineHeight: 1.6,
    letterSpacing: 0,
    padding: '9px 0 5px',
    textAlign: 'right',
    pointerEvents: 'none',
  },
  boxLbl2: {
    zIndex: 2,
    color: theme.palette.primaryColor,
    background: '#fff',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.3,
    letterSpacing: 0,
    padding: '9px 0 5px',
    width: '100%',
    textAlign: 'right',
    justifyContent: 'flex-end',
    wordBreak: 'break-all',
  },
  lblWrap: {
    width: '70%',
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: 'right',
    '& span': {
      textAlign: 'right',
      justifyContent: 'flex-end',
    },
  },
  imgWrap: {
    maxWidth: '80%',
    position: 'relative',
    flexGrow: 1,
    padding: '8px',
    borderBottom: '1px #f3f3f3 solid',
  },
  input: { opacity: 0 },
  hiddenInput: { opacity: 0, pointerEvents: 'none' },
  dialogTitle: {
    padding: '16px',
  },
  titleTxt: {
    fontSize: 13,
    width: '100%',
    textAlign: 'center',
    fontWeight: '700',
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'center',
  },
  closeBtn: {
    padding: '6px 20px',
    margin: '0 8px',
    fontSize: 13,
  },
}));

function RegisterCustomerCardFileSp(props) {
  const { fileData = {}, onChange } = props;
  const common = commonStyles();
  const classes = useStyles();
  const gCommon = gensenStyle();

  const deleteFunc = () => {
    onChange({});
  };

  const onFileInputChange = async (e) => {
    const inputFile = e.target.files[0]; // fileList obj
    // 画像ファイルのみが対象にする
    if (/^image/.test(inputFile.type)) {
      const compressedImage = await compressImage(inputFile);
      const data = {
        file: compressedImage,
        fileName: formatFileName(inputFile).join('.'),
      };
      onChange(data);
    } else if (/^application\/pdf/.test(inputFile.type)) {
      const data = {
        file: inputFile,
        fileName: formatFileName(inputFile).join('.'),
      };
      onChange(data);
    }
    // 表示名変更後に再度同じファイルをアップできるようにするため
    e.target.value = '';
  };

  return (
    <Grid container className={gCommon.blockWrap}>
      <Button
        className={classes.deleteBtn}
        onClick={deleteFunc}
      >
        <DeleteOutline className={gCommon.icon} />
        <Typography>削除</Typography>
      </Button>
      <Grid className={classes.imgWrap}>
        <Grid className={gCommon.display}>
          <Typography className={`${common.title6} ${gCommon.ttl3}`}>ファイル<span>＊</span></Typography>
          <Grid className={classes.inputWrap}>
            {fileData.fileName ? (
              <Button className={classes.boxLbl2} onClick={() => {}}>
                {fileData.file.name}
              </Button>
            ) : (
              <Typography className={classes.boxLbl}>アップロード</Typography>
            )}
            <Input
              type="file"
              onChange={(ev) => onFileInputChange(ev)}
              inputProps={{
                accept: 'image/*, .pdf',
              }}
              className={fileData.fileName ? classes.hiddenInput : classes.input}
            />
          </Grid>
        </Grid>
        <Grid className={gCommon.display}>
          <Typography className={`${common.title6} ${gCommon.ttl}`}>表示名<span>＊</span></Typography>
          <ImageNameField
            value={fileData.fileName}
            onChange={(newName) => {
              onChange({
                ...fileData,
                fileName: newName,
              });
            }}
            label="表示名"
            readOnly={!fileData.fileName}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

function ImageNameField(props) {
  const { value, onChange, readOnly } = props;
  const gCommon = gensenStyle();
  const [fileName, setFileName] = useState('');
  const [extension, setExtension] = useState('');

  useEffect(() => {
    if (fileName !== value) {
      const [_extension, ..._fileName] = value?.split('.').reverse() || ['', value];
      setFileName(_fileName);
      setExtension(_extension);
    }
  }, [value]);

  return (
    <TextField
      value={fileName}
      className={`${gCommon.txtfield} ${readOnly && gCommon.readOnlyTxtField}`}
      placeholder="-"
      onChange={(e) => {
        setFileName(e.target.value);
      }}
      onBlur={() => {
        onChange(`${fileName}.${extension}`);
      }}
      disabled={!value}
    />
  );
}

export default RegisterCustomerCardFileSp;
